export enum TrueFalseEnum {
    False = 0,
    True = 1
}

export enum ReasonEnum {
    SigningDifferentFacility = 43,
    SigningThisFacility = 44,
    SigningAya = 45,
    BetterPay = 17,
    Other = 53,
    Unknown = 22
}

export enum VendorEnum {
    Other = 0
}
